export default [
  {
    icon: "mdi-view-dashboard",
    title: "Dashboard",
    name: "Dashboard",
    i18n: "Home",
    permissions: "dashboard",
  },

  {
    icon: "mdi-calendar-month",
    title: "Schedule",
    name: "Schedule",
    i18n: "Schedule",
    permissions: "schedule",
  },

  {
    title: "Time Off",
    icon: "mdi-calendar",
    i18n: "Time Off",
    name: "TimeOff",
    permissions: "timeOff",
  },

  {
    title: "Announcements",
    icon: "mdi-alert-box",
    i18n: "Announcement",
    name: "Announcement",
    permissions: "announcement",
  },

  {
    title: "Reports",
    icon: "mdi-file-chart",
    i18n: "Reports",
    name: "Reports",
    permissions: "report",
  },

  {
    icon: "mdi-card-account-details",
    title: "Clients",
    name: "Clients",
    i18n: "Clients",
    permissions: "client",
  },

  {
    title: "Files",
    icon: "mdi-folder",
    i18n: "Storage",
    name: "Storage",
    permissions: "storage",
  },

  {
    icon: "mdi-lock",
    title: "Password Vault",
    name: "PasswordVault",
    i18n: "PasswordVault",
    permissions: "vault",
  },

  {
    icon: "work",
    title: "Jobs",
    name: "TaskList",
    i18n: "TaskList",
    permissions: "task",
  },

  {
    icon: "mdi-timer",
    title: "Time Clock",
    name: "TimeClock",
    i18n: "TimeClock",
    permissions: "timeClock",
  },

  {
    icon: "request_quote",
    title: "Bids",
    name: "Quotes",
    i18n: "Quotes",
    permissions: "quote",
  },
  
  {
    title: "Users",
    icon: "person",
    i18n: "User",
    name: "Users",
    permissions: "user",
  },

  {
    title: "User Groups",
    icon: "supervised_user_circle",
    i18n: "User Groups",
    name: "UserGroup",
    permissions: "userGroup",
  },
];
